import { render, staticRenderFns } from "./MicrosoftCallback.vue?vue&type=template&id=0a5a4aa2&scoped=true&"
import script from "./MicrosoftCallback.vue?vue&type=script&lang=ts&"
export * from "./MicrosoftCallback.vue?vue&type=script&lang=ts&"
import style0 from "./MicrosoftCallback.vue?vue&type=style&index=0&id=0a5a4aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a4aa2",
  null
  
)

export default component.exports